import { formatCurrency, getCurrencySymbol } from '@angular/common';
import {
  AfterViewInit,
  HostListener,
  Component,
  ElementRef,
  Inject,
  LOCALE_ID,
  OnDestroy,
  OnInit,
  Renderer2,
  ViewChild,
  ChangeDetectorRef,
  NgZone,
} from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DatatableComponent } from '@swimlane/ngx-datatable';
import { ListaPrecoTabelaService } from '../../../../../shared/services/lista-preco-tabela.service';
import { Utils } from '../../../../../utils/utils';
import { BehaviorSubject, Observable, Subject, timer } from 'rxjs';
import { debounceTime, finalize, retry, share, switchMap, takeUntil, tap, filter, map, delay } from 'rxjs/operators';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { BarcodeSelectionDialogComponent } from './barcode-selection-dialog.component';
import { Estados } from '../../../../../shared/inmemory-db/estados';
import { CST } from '../../../../../shared/inmemory-db/cst';
import { ModalidadeFrete } from '../../../../../shared/inmemory-db/modalidade-frete';
import { Cadastro } from '../../../../../shared/interfaces/cadastro';
import { Condpg } from '../../../../../shared/interfaces/condpg';
import { Estado } from '../../../../../shared/interfaces/estado';
import { FatDoctoC } from '../../../../../shared/interfaces/fat-docto-c';
import { FatDoctoCCce } from '../../../../../shared/interfaces/fat-docto-cc-ce';
import { FatDoctoI, ItemID } from '../../../../../shared/interfaces/fat-docto-i';
import { FatDoctoRef } from '../../../../../shared/interfaces/fat-docto-ref';
import { FatSerie } from '../../../../../shared/interfaces/fat-serie';
import { FinancRp } from '../../../../../shared/interfaces/financ-rp';
import { ListaPreco } from '../../../../../shared/interfaces/lista-preco';
import { ListaPrecoTabela } from '../../../../../shared/interfaces/lista-preco-tabela';
import { Log } from '../../../../../shared/interfaces/log';
import { PageResult } from '../../../../../shared/interfaces/page-result';
import { Produto } from '../../../../../shared/interfaces/produto';
import { Transacao } from '../../../../../shared/interfaces/transacao';
import { PRODUTO_TIPOS_COM_DESPESA } from '../../../../../shared/constants/produto-tipos.constants';
import { AppConfirmService } from '../../../../../shared/services/app-confirm/app-confirm.service';
import { AppLoaderProgressService } from '../../../../../shared/services/app-loader-progress/app-loader-progress.service';
import { AppLoaderService } from '../../../../../shared/services/app-loader/app-loader.service';
import { CadastroService } from '../../../../../shared/services/cadastro.service';
import { FatDoctoCService } from '../../../../../shared/services/fat-docto-c.service';
import { ProdutoService } from '../../../../../shared/services/produto.service';
import { LayoutService } from '../../../../../shared/services/layout.service';
import { LancamentoItemDIListComponent } from '../lacamento-item-di-list/lancamento-item-di-list.component';
import { LancamentoItemDetailsComponent } from '../lancamento-item-details/lancamento-item-details.component';
import { ProdutoPopupComponent } from '../../../../cadastro/faturamento/produto/produto-popup/produto-popup.component';
import { ProdutoDetailsComponent } from '../../../../cadastro/faturamento/produto/produto-details/produto-details.component';
import { ProdutoManutencaoPrecoComponent } from '../../../../cadastro/faturamento/produto-manutencao-preco/produto.manutencao.preco.component';

@Component({
  selector: 'app-lancamento-itens',
  templateUrl: 'lancamento-itens.component.html',
  styleUrls: ['lancamento-itens.component.scss'],
})
export class LancamentoItensComponent implements OnInit, AfterViewInit, OnDestroy {
  sortDir = {
    codigo: 'asc' as 'asc' | 'desc',
    descricao: 'asc' as 'asc' | 'desc',
    issueDate: 'asc' as 'asc' | 'desc',
  };
  lctoItens = '';
  protected _onDestroy = new Subject<void>();

  @ViewChild(MatPaginator, { static: false }) paginatorItem: MatPaginator;
  @ViewChild('ngxDatatable') ngxDatatable: DatatableComponent;
  @ViewChild('produtoSearch') produtoSearchInput: ElementRef;
  @ViewChild('mobileBarcodeInputRef') mobileBarcodeInputRef: ElementRef<HTMLInputElement>;
  @ViewChild('desktopBarcodeInputRef') desktopBarcodeInputRef: ElementRef<HTMLInputElement>;
  @ViewChild('mobileBarcodeVideo') mobileBarcodeVideoRef: ElementRef<HTMLVideoElement>;
  @ViewChild('mobileItemsScrollRef') mobileItemsScrollRef?: ElementRef<HTMLDivElement>;

  public doctoCForm: FormGroup;
  doctoIForm: FormGroup;
  public itemDiretivasFatForm: FormGroup;

  modalidadesFrete: any[];
  estados: Estado[];
  CST = new CST();
  lcto: FatDoctoC;
  selectedTabIndex = 0;

  fatTransacoes: Transacao[];
  fatTransacao: Transacao;
  isLoadingFatTransacao = false;

  produtos: Produto[] = [];
  produtos$: BehaviorSubject<Produto[]> = new BehaviorSubject<Produto[]>([]);
  produto!: Produto;
  isLoadingProduto = false;

  series: FatSerie[];
  serie: FatSerie;
  isLoadingSerie = false;

  doctoCs: FatDoctoC[];
  doctoC: FatDoctoC;
  isLoadingDoctoC = false;

  destinatarios: Cadastro[];
  destinatario: Cadastro;
  isLoadingDestinatario = false;

  vendedores: Cadastro[];
  vendedor: Cadastro;
  isLoadingVendedor = false;

  transps: Cadastro[];
  transp: Cadastro;
  isLoadingTransp = false;

  motoristas: Cadastro[];
  motorista: Cadastro;
  isLoadingMotorista = false;

  condPgs: Condpg[];
  condPg: Condpg;
  isLoadingCondPg = false;

  listaPrecos$: BehaviorSubject<ListaPreco[]> = new BehaviorSubject<ListaPreco[]>([]);
  listaPreco: ListaPreco;
  isLoadingPreco = false;

  tabelas$: BehaviorSubject<ListaPrecoTabela[]> = new BehaviorSubject<ListaPrecoTabela[]>([]);
  tabela: ListaPrecoTabela;
  isLoadingTabela = false;

  pageObjectDoctoI$: BehaviorSubject<PageResult<FatDoctoI>> = new BehaviorSubject<PageResult<FatDoctoI>>(null);
  searchEntry$: Subject<string> = new Subject<string>();
  produtoItemExists$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  doctoIs: FatDoctoI[];
  doctoIs$: BehaviorSubject<FatDoctoI[]> = new BehaviorSubject<FatDoctoI[]>([]);
  doctoI: FatDoctoI;
  saveItem = false;
  page = { offset: 0 };
  pageItem = 1;
  lengthItem = 0;
  pageSizeItem = 1000;
  pageEventItem = null;
  pageSizeOptionsItem: number[] = [100, 500, 1000];
  selectedItemOrdem = 'NENHUM';
  selectedItemDirect = 'ASC';
  public searchInput = '';

  mouseoverAutoriza = false;
  mouseoverCancela = false;
  errorMsg: string;

  maskFone = { mask: '(00) {*}0000-0000', lazy: true, placeholderChar: '_' };
  maskCep = { mask: '00000-000', lazy: true, placeholderChar: '_' };
  maskCfop = { mask: '0000', lazy: true, placeholderChar: '_' };
  maskCpf = { mask: '000.000.000-00', lazy: true, placeholderChar: '_' };
  maskCnpj = { mask: '00.000.000/0000-00', lazy: true, placeholderChar: '_' };
  maskUpper = { mask: /^\w\s*/, prepare: (str: any) => str.toUpperCase() };
  maskLower = { mask: /^\w\s*/, prepare: (str: any) => str.toLowerCase() };
  maskEmail = { mask: /^\S*@?\S*$/, prepare: (email: any) => email.toLowerCase() };

  newItem = {} as FatDoctoI;
  isEditableDoctI = {};
  isEditableParcela = {};
  parcelas: FinancRp[] = new Array();
  private stopPolling = new Subject();
  precoPadrao: any;
  refs: FatDoctoRef[];
  cartaCorrecoes: FatDoctoCCce[];
  controle: any;
  showEditOption: boolean;
  openModal = false;
  deniedInitData: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  utils = Utils;
  max = null;
  workDone = null;
  it = 0;
  maxRetry = 20;
  created = false;
  disabled: true;
  public layoutConf: any;
  public searching = false;
  public mobileItemSearch = '';
  public mobileItemSortBy: 'inclusao' | 'issueDate' | 'produto' | 'valorTotal' | 'qtde' = 'inclusao';
  public mobileItemSortDir: 'asc' | 'desc' = 'asc';
  public mobileBarcodeInput = '';
  public mobileBarcodeSearching = false;
  public mobileManualBarcodeInput = false;
  public mobileCameraScanning = false;
  public mobileCameraBusy = false;
  private mobileScannerStream: MediaStream | null = null;
  private mobileScannerIntervalId: number | null = null;
  private keyboardScanBuffer = '';
  private keyboardScanLastTs = 0;
  private keyboardScanFastMode = false;
  private keyboardScanTimeoutId: number | null = null;
  private readonly keyboardScanMaxGapMs = 80;
  private readonly keyboardScanIdleResetMs = 350;
  private barcodeScanQueue: string[] = [];
  private barcodeScanProcessing = false;
  private barcodePersistRequested = false;
  private barcodePersistTimerId: number | null = null;
  private readonly barcodePersistDelayMs = 320;
  private barcodeAutoModeActive = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<LancamentoItensComponent>,
    @Inject(LOCALE_ID) private locale: string,
    private fb: FormBuilder,
    private dialog: MatDialog,
    private confirmService: AppConfirmService,
    private fatDoctoCService: FatDoctoCService,
    private produtoService: ProdutoService,
    private cadastroService: CadastroService,
    private tabelaPrecoService: ListaPrecoTabelaService,
    private snack: MatSnackBar,
    private loader: AppLoaderService,
    private progressLoader: AppLoaderProgressService,
    private renderer: Renderer2,
    private layout: LayoutService,
    private zone: NgZone,
    private cdr: ChangeDetectorRef,
  ) {
    this.modalidadesFrete = new ModalidadeFrete().modalidades;
    this.estados = new Estados().estados;
  }

  ngOnInit() {
    console.log('INIT LIST ITENS');
    this.layoutConf = this.layout.layoutConf;
    this.doctoCForm = this.data.payload;
    this.lcto = this.doctoCForm.value;
    this.controle = this.lcto?.controle;

    this.doctoIs$.subscribe((log) => {
      this.doctoIs = log.map((val) => val);
    });

    this.reloadLctoItens(this.lcto);

    this.pageObjectDoctoI$.subscribe((page) => {
      this.doctoCForm.setControl('items', this.fb.array([]));
      console.log('this.pageObjectDoctoI$.subscribe');
      if (page != null) {
        const serverContent = Array.isArray(page.content) ? [...page.content] : [];
        const shouldKeepServerOrder = this.selectedItemOrdem === 'ISSUEDATE' || this.selectedItemOrdem === 'NENHUM';
        const mergedContent = shouldKeepServerOrder
          ? serverContent
          : this.mergeItemsKeepingDisplayOrder(serverContent);
        const orderedContent = shouldKeepServerOrder
          ? mergedContent
          : this.sortItemsByInclusionAsc(mergedContent);
        this.zone.run(() => {
          this.doctoIs$.next(orderedContent);
        });
        this.doctoIs = orderedContent;
        this.lengthItem = page.totalElements;
        this.pageSizeItem = page.size;
        this.pageItem = page.number;
        orderedContent.forEach((i) => {
          this.addDoctoI(i);
        });
        this.doctoCForm.setControl('items', this.itemFormArray);
        if (this.pageItem === 1) {
          this.paginatorItem.firstPage();
        }
      } else {
        this.doctoIs = [];
        this.doctoIs$.next([]);
      }
      this.loader.close();
    });

    this.getPageItem(this.pageItem, this.pageSizeItem, this.lcto?.controle);
    this.debounceTimeSearchItem();

    this.doctoCForm
      .get('produtoSearch')
      ?.valueChanges.pipe(
        filter((search) => !!search),
        tap(() => (this.searching = true)),
        takeUntil(this._onDestroy),
        debounceTime(200),
        map((search) => {
          return this.produtoService
            .getProdutoPageSearch(1, 30, search, 'NENHUM', 'ASC', false, false, PRODUTO_TIPOS_COM_DESPESA)
            .subscribe((page) => {
              this.produtos = [...(page.content || [])];
            });
        }),
        delay(200),
        takeUntil(this._onDestroy)
      )
      .subscribe(
        (result) => {
          this.searching = false;
        },
        (error) => {
          this.searching = false;
          this.confirmService.confirm({
            message: `A T E N Ç Ã O !  ERRO PESQUISANDO PRODUTO ... ${error}`,
            error: true,
          });
        }
      );
  }

  trackByProdutoId(index: number, item: Produto): any {
    return item?.id ?? item?.codigo ?? index;
  }

  reloadLctoItens(lcto: FatDoctoC) {
    this.lctoItens =
      'CONTROLE:' +
      lcto.controle +
      ' - TOTAL DO LCTO:' +
      formatCurrency(lcto.valortotalDocto, this.locale, getCurrencySymbol('BRL', 'wide'));
  }

  ngAfterViewInit() {
    this.cdr.detectChanges();
    setTimeout(() => {
      if (this.ngxDatatable) {
        this.ngxDatatable.recalculate();
        this.ngxDatatable.recalculateColumns();
        setTimeout(() => {
          this.ngxDatatable.recalculate();
        }, 100);
      }
    }, 0);

    this.dialogRef.afterOpened().subscribe(() => {
      let lastObservedWidth = 0;
      let lastObservedHeight = 0;
      let resizeRafId: number | null = null;

      const resizeObserver = new ResizeObserver((entries) => {
        if (!this.ngxDatatable || !entries?.length) {
          return;
        }

        const rect = entries[0]?.contentRect;
        const nextWidth = Math.round(rect?.width ?? 0);
        const nextHeight = Math.round(rect?.height ?? 0);

        if (nextWidth === lastObservedWidth && nextHeight === lastObservedHeight) {
          return;
        }

        lastObservedWidth = nextWidth;
        lastObservedHeight = nextHeight;

        if (resizeRafId != null) {
          cancelAnimationFrame(resizeRafId);
        }

        resizeRafId = requestAnimationFrame(() => {
          this.ngxDatatable?.recalculate();
          this.ngxDatatable?.recalculateColumns();
          resizeRafId = null;
        });
      });
      resizeObserver.observe(document.querySelector('.mat-dialog-container') as Element);
      this._onDestroy.subscribe(() => {
        if (resizeRafId != null) {
          cancelAnimationFrame(resizeRafId);
          resizeRafId = null;
        }
        resizeObserver.disconnect();
      });

      if (!this.layoutConf?.isMobile) {
        setTimeout(() => this.focusDesktopBarcodeInput(), 80);
      }
    });
  }

  ngOnDestroy() {
    this.stopMobileBarcodeCamera();
    this.clearKeyboardScanBuffer();
    this.clearBarcodePersistTimer();
    this.barcodeScanQueue = [];
    this.barcodeScanProcessing = false;
    this._onDestroy.next();
    this._onDestroy.complete();
    this.stopPolling.next();
    this.stopPolling.complete();
  }

  @HostListener('document:keydown', ['$event'])
  onGlobalKeydown(event: KeyboardEvent) {
    if (this.shouldUseCameraScanner()) {
      return;
    }

    const target = event.target as HTMLElement;
    const insideDatatable = !!target?.closest?.('.ngx-datatable');
    const isTypingElement =
      target instanceof HTMLInputElement ||
      target instanceof HTMLTextAreaElement ||
      target instanceof HTMLSelectElement ||
      !!target?.isContentEditable;

    const barcodeInputFocused =
      target === this.desktopBarcodeInputRef?.nativeElement || target === this.mobileBarcodeInputRef?.nativeElement;

    // If user is typing in any editable field, do not hijack keys.
    // Scanner capture should only happen when focus is outside editable inputs.
    if (barcodeInputFocused || isTypingElement) {
      this.clearKeyboardScanBuffer();
      return;
    }

    if (event.ctrlKey || event.altKey || event.metaKey) {
      return;
    }

    const key = event.key || '';
    const isPrintable = key.length === 1;
    const isEnter = key === 'Enter';
    if (!isPrintable && !isEnter) {
      return;
    }

    const now = Date.now();
    const delta = this.keyboardScanLastTs ? now - this.keyboardScanLastTs : 0;
    this.keyboardScanLastTs = now;

    if (isPrintable) {
      if (!this.keyboardScanBuffer || delta <= this.keyboardScanMaxGapMs) {
        this.keyboardScanFastMode = this.keyboardScanBuffer.length > 0 ? this.keyboardScanFastMode : false;
      } else {
        this.keyboardScanBuffer = '';
        this.keyboardScanFastMode = false;
      }

      if (delta > 0 && delta <= this.keyboardScanMaxGapMs && this.keyboardScanBuffer.length >= 1) {
        this.keyboardScanFastMode = true;
      }

      this.keyboardScanBuffer += key;
      this.armKeyboardScanTimeout();

      if (this.keyboardScanFastMode && this.keyboardScanBuffer.length >= 3) {
        event.preventDefault();
        event.stopPropagation();
      }
      return;
    }

    if (isEnter && this.keyboardScanFastMode && this.keyboardScanBuffer.length >= 4) {
      event.preventDefault();
      event.stopPropagation();
      this.mobileBarcodeInput = this.keyboardScanBuffer;
      this.clearKeyboardScanBuffer();
      this.addItemByBarcodeMobile();
      return;
    }

    this.clearKeyboardScanBuffer();
  }

  private armKeyboardScanTimeout() {
    if (this.keyboardScanTimeoutId != null) {
      window.clearTimeout(this.keyboardScanTimeoutId);
    }

    this.keyboardScanTimeoutId = window.setTimeout(() => {
      this.clearKeyboardScanBuffer();
    }, this.keyboardScanIdleResetMs);
  }

  private clearKeyboardScanBuffer() {
    if (this.keyboardScanTimeoutId != null) {
      window.clearTimeout(this.keyboardScanTimeoutId);
      this.keyboardScanTimeoutId = null;
    }
    this.keyboardScanBuffer = '';
    this.keyboardScanLastTs = 0;
    this.keyboardScanFastMode = false;
  }

  private requestBarcodePersist() {
    this.barcodeAutoModeActive = true;
    this.barcodePersistRequested = true;
    if (this.barcodePersistTimerId != null) {
      window.clearTimeout(this.barcodePersistTimerId);
    }
    this.barcodePersistTimerId = window.setTimeout(() => this.flushBarcodePersist(), this.barcodePersistDelayMs);
  }

  private flushBarcodePersist() {
    this.barcodePersistTimerId = null;
    if (!this.barcodePersistRequested) {
      return;
    }

    if (this.saveItem) {
      this.barcodePersistTimerId = window.setTimeout(() => this.flushBarcodePersist(), this.barcodePersistDelayMs);
      return;
    }

    this.barcodePersistRequested = false;
    this.save(false, false);
  }

  private clearBarcodePersistTimer() {
    if (this.barcodePersistTimerId != null) {
      window.clearTimeout(this.barcodePersistTimerId);
      this.barcodePersistTimerId = null;
    }
    this.barcodePersistRequested = false;
    this.barcodeAutoModeActive = false;
  }

  private isLctoLockedError(err: any): boolean {
    const status = String(err?.error?.status || err?.message || '').toUpperCase();
    return status.includes('LCTO BLOQUEADO POR OUTRA OPERA') || status.includes('SALVANDO LAN') || status.includes('LOCK');
  }

  reloadFormItens() {
    this.doctoCForm.setControl('items', this.fb.array([]));
    this.doctoIs.forEach((i) => {
      this.addDoctoI(i);
    });
    this.doctoCForm.setControl('items', this.itemFormArray);
  }

  addDoctoI(doctoI: FatDoctoI) {
    console.log('ITEM>' + this.codigoCst(doctoI.icmsClasstrib ?? ''));
    this.itemFormArray.push(
      this.fb.group({
        id: [doctoI.id],
        uuid: [doctoI.uuid],
        produto: [doctoI?.id.fatProduto],
        qtde: [doctoI.qtde],
        valorUnitario: [doctoI.valorUnitario],
        valorTotal: [doctoI.valorTotal],
        descPercUnitario: [doctoI.descPercUnitario],
        descValorUnitario: [doctoI.descValorUnitario],
        valorUnitarioLiquido: [doctoI.valorUnitarioLiquido],
        valorTotalLiquido: [doctoI.valorTotalLiquido],
        tabCfopId: [doctoI.tabCfopId],
        icmsClasstrib: [doctoI.icmsClasstrib],
        icmsDigitacaomanual: [doctoI.icmsDigitacaomanual],
        icmsBasecalculo: [doctoI.icmsBasecalculo],
        icmsPerc: [doctoI.icmsPerc],
        icmsValor: [doctoI.icmsValor],
        ipiDigitacaomanual: [doctoI.ipiDigitacaomanual],
        ipiPercentual: [doctoI.ipiPercentual],
        ipiValor: [doctoI.ipiValor],
        pisBasecalculo: [doctoI.pisBasecalculo],
        pisPerc: [doctoI.pisPerc],
        pisValor: [doctoI.pisValor],
        cofinsBasecalculo: [doctoI.cofinsBasecalculo],
        cofinsPerc: [doctoI.cofinsPerc],
        cofinsValor: [doctoI.cofinsValor],
        infAdProd: [doctoI.infAdProd],
        importacaoValorBaseCalculo: [doctoI.importacaoValorBaseCalculo],
        importacaoValorDespesaAduaneira: [doctoI.importacaoValorDespesaAduaneira],
        importacaoValorImpostoImportacao: [doctoI.importacaoValorImpostoImportacao],
        importacaoValorIOF: [doctoI.importacaoValorIOF],
        informaImpostoImportacao: [doctoI.informaImpostoImportacao],
        beneficioFiscal: [doctoI.beneficioFiscal],
        codigoBeneficioFiscalUF: [doctoI.codigoBeneficioFiscalUF],
        ibsCbsClasstrib: [doctoI.ibsCbsClasstrib],
        ibsCbsDigitacaoManual: [doctoI.ibsCbsDigitacaoManual],
        ibsCbsBaseCalculo: [doctoI.ibsCbsBaseCalculo],
        ibsAliquota: [doctoI.ibsAliquota],
        ibsAliquotaMun: [doctoI.ibsAliquotaMun],
        ibsValor: [doctoI.ibsValor],
        ibsValorMun: [doctoI.ibsValorMun],
        cbsAliquota: [doctoI.cbsAliquota],
        cbsAliquotaMun: [doctoI.cbsAliquotaMun],
        cbsValor: [doctoI.cbsValor],
        cbsValorMun: [doctoI.cbsValorMun],
      })
    );
  }

  codigoCst(codgo: string): string {
    return this.CST.getByCodJkaw(codgo ?? '')?.codigo ?? '';
  }

  get itemFormArray(): FormArray {
    return this.doctoCForm.get('items') as FormArray;
  }

  getDatatableRowClass = (row: any) => {
    const idx = this.itemFormArray?.controls?.indexOf(row as any) ?? -1;
    return idx >= 0 && this.isEditableDoctI[idx] ? 'editing-row' : '';
  };

  private mergeItemsKeepingDisplayOrder(serverItems: FatDoctoI[]): FatDoctoI[] {
    const incoming = Array.isArray(serverItems) ? [...serverItems] : [];
    const current = Array.isArray(this.doctoIs) ? this.doctoIs : [];

    if (current.length === 0 || incoming.length <= 1) {
      return incoming;
    }

    const orderMap = new Map<string, number>();
    current.forEach((item, index) => {
      orderMap.set(this.getDoctoIOrderKey(item), index);
    });

    return incoming
      .map((item, serverIndex) => {
        const key = this.getDoctoIOrderKey(item);
        const oldIndex = orderMap.has(key) ? (orderMap.get(key) as number) : Number.MAX_SAFE_INTEGER;
        return { item, oldIndex, serverIndex };
      })
      .sort((a, b) => {
        if (a.oldIndex !== b.oldIndex) {
          return a.oldIndex - b.oldIndex;
        }
        return a.serverIndex - b.serverIndex;
      })
      .map((entry) => entry.item);
  }

  private sortItemsByInclusionAsc(items: FatDoctoI[]): FatDoctoI[] {
    const source = Array.isArray(items) ? [...items] : [];

    return source
      .map((item, idx) => ({ item, idx }))
      .sort((a, b) => {
        const ordemA = this.getNumericInclusionOrder(a.item?.ordemdigitacao);
        const ordemB = this.getNumericInclusionOrder(b.item?.ordemdigitacao);
        const hasOrdemA = Number.isFinite(ordemA);
        const hasOrdemB = Number.isFinite(ordemB);

        if (hasOrdemA && hasOrdemB && ordemA !== ordemB) {
          return ordemA - ordemB;
        }

        const seqA = Number(a.item?.seqInclusao ?? Number.NaN);
        const seqB = Number(b.item?.seqInclusao ?? Number.NaN);
        const hasSeqA = Number.isFinite(seqA);
        const hasSeqB = Number.isFinite(seqB);

        if (hasSeqA && hasSeqB && seqA !== seqB) {
          return seqA - seqB;
        }

        const tsA = this.getInclusionTimestamp(a.item);
        const tsB = this.getInclusionTimestamp(b.item);
        if (tsA !== tsB) {
          return tsA - tsB;
        }

        // Fallback: API costuma retornar inclusão em ordem decrescente.
        // Inverte para manter exibição crescente (mais antigo -> mais novo).
        return b.idx - a.idx;
      })
      .map((entry) => entry.item);
  }

  private getNumericInclusionOrder(value: any): number {
    if (value == null) {
      return Number.NaN;
    }

    const normalized = String(value).replace(/[^0-9.-]/g, '');
    const parsed = Number(normalized);
    return Number.isFinite(parsed) ? parsed : Number.NaN;
  }

  private getInclusionTimestamp(item: FatDoctoI): number {
    const issueDateLong = Number(item?.issueDateLong ?? Number.NaN);
    if (Number.isFinite(issueDateLong)) {
      return issueDateLong;
    }

    const horaMs = this.getHoraInclusaoMs(item?.horainclusao);

    const dataInclusao = item?.datainclusao ? new Date(item.datainclusao as any).getTime() : Number.NaN;
    if (Number.isFinite(dataInclusao)) {
      if (Number.isFinite(horaMs)) {
        const date = new Date(item.datainclusao as any);
        if (!Number.isNaN(date.getTime())) {
          date.setHours(
            Math.floor(horaMs / 3600000),
            Math.floor((horaMs % 3600000) / 60000),
            Math.floor((horaMs % 60000) / 1000),
            0
          );
          return date.getTime();
        }
      }
      return dataInclusao;
    }

    const issueDate = item?.issueDate ? new Date(item.issueDate as any).getTime() : Number.NaN;
    if (Number.isFinite(issueDate)) {
      return issueDate;
    }

    if (Number.isFinite(horaMs)) {
      return horaMs;
    }

    return Number.MAX_SAFE_INTEGER;
  }

  private getIssueDateTimestamp(item: FatDoctoI): number {
    const rawIssueDate = item?.issueDate;
    if (rawIssueDate == null) {
      return Number.NaN;
    }

    if (rawIssueDate instanceof Date) {
      const dateTs = rawIssueDate.getTime();
      return Number.isFinite(dateTs) ? dateTs : Number.NaN;
    }

    const parsedTs = Date.parse(String(rawIssueDate));
    return Number.isFinite(parsedTs) ? parsedTs : Number.NaN;
  }

  private getHoraInclusaoMs(rawHora: any): number {
    const hora = (rawHora || '').toString().trim();
    if (!hora) {
      return Number.NaN;
    }

    const parts = hora.split(':').map((v) => Number(v || 0));
    if (parts.length < 2 || parts.length > 3) {
      return Number.NaN;
    }

    const h = parts[0];
    const m = parts[1];
    const s = parts.length === 3 ? parts[2] : 0;

    if (!Number.isFinite(h) || !Number.isFinite(m) || !Number.isFinite(s)) {
      return Number.NaN;
    }

    return (h * 3600 + m * 60 + s) * 1000;
  }

  private getDoctoIOrderKey(item: any): string {
    const controle = item?.id?.fatDoctoCControle ?? '';
    const produtoId = item?.id?.fatProduto?.id ?? item?.id?.fatProduto ?? '';
    return `${controle}-${produtoId}`;
  }

  toggleMobileItemSortDir() {
    this.mobileItemSortDir = this.mobileItemSortDir === 'asc' ? 'desc' : 'asc';
  }

  getMobileItemRows(): Array<{ row: any; index: number }> {
    const rows = (this.itemFormArray?.controls || []).map((row, index) => ({ row, index }));
    const search = (this.mobileItemSearch || '').toString().toLowerCase().trim();

    const filtered = !search
      ? rows
      : rows.filter((item) => {
          const value = item.row?.value || {};
          const produto = `${value?.id?.fatProduto?.codigo || ''} ${value?.id?.fatProduto?.descricao || ''}`.toLowerCase();
          const cfop = `${value?.tabCfopId || ''}`.toLowerCase();
          const cst = `${value?.icmsClasstrib || ''}`.toLowerCase();
          return produto.includes(search) || cfop.includes(search) || cst.includes(search);
        });

    return filtered.sort((a, b) => {
      const av = a.row?.value || {};
      const bv = b.row?.value || {};
      let result = 0;

      if (this.mobileItemSortBy === 'inclusao') {
        result = a.index - b.index;
      } else if (this.mobileItemSortBy === 'issueDate') {
        const tsA = this.getIssueDateTimestamp(av);
        const tsB = this.getIssueDateTimestamp(bv);
        const hasA = Number.isFinite(tsA);
        const hasB = Number.isFinite(tsB);

        if (hasA && hasB) {
          result = tsA - tsB;
        } else if (hasA !== hasB) {
          result = hasA ? -1 : 1;
        } else {
          result = a.index - b.index;
        }
      } else if (this.mobileItemSortBy === 'valorTotal') {
        result = Number(av?.valorTotal || 0) - Number(bv?.valorTotal || 0);
      } else if (this.mobileItemSortBy === 'qtde') {
        result = Number(av?.qtde || 0) - Number(bv?.qtde || 0);
      } else {
        const an = `${av?.id?.fatProduto?.codigo || ''} ${av?.id?.fatProduto?.descricao || ''}`.toLowerCase();
        const bn = `${bv?.id?.fatProduto?.codigo || ''} ${bv?.id?.fatProduto?.descricao || ''}`.toLowerCase();
        result = an.localeCompare(bn);
      }

      return this.mobileItemSortDir === 'asc' ? result : -result;
    });
  }

  trackByMobileItemIndex(_i: number, item: { row: any; index: number }): number {
    return item?.index ?? _i;
  }

  enterPressedOnValorUnLiq() {
    console.log('enterPressedOnValorUnLiq');
    this.produtoSearchInput.nativeElement.focus();
    this.produtoSearchInput.nativeElement.select();
  }

  changeQtdeOrValorUnitario(row: FormGroup) {
    const newValorTotal = row.controls['valorUnitario'].value * row.controls['qtde'].value;
    if (row.controls['valorTotal'].value !== newValorTotal) {
      row.controls['valorTotal'].setValue(newValorTotal);
    }
  }

  changeValorTotal(row: FormGroup) {
    if (row.controls['qtde'].value === 0 && row.controls['valorUnitario'].value > 0) {
      const newQtde = row.controls['valorTotal'].value / row.controls['valorUnitario'].value;
      console.log('newQtde>>>>>>>' + newQtde);
      if (row.controls['qtde'].value !== newQtde) {
        row.controls['qtde'].setValue(newQtde);
      }
    } else if (row.controls['qtde'].value > 0 && row.controls['valorUnitario'].value === 0) {
      const newValorUnitario = row.controls['valorTotal'].value / row.controls['qtde'].value;
      if (row.controls['valorUnitario'].value !== newValorUnitario) {
        row.controls['valorUnitario'].setValue(newValorUnitario);
        console.log('valorUnitario>>>>>>>' + row.controls['valorUnitario'].value);
      }
    } else {
      const newValorTotal = row.controls['valorUnitario'].value * row.controls['qtde'].value;
      if (row.controls['valorTotal'].value !== newValorTotal) {
        row.controls['valorTotal'].setValue(newValorTotal);
        row.controls['valorUnitarioLiquido'].setValue(
          row.controls['valorUnitario'].value - row.controls['descValorUnitario'].value
        );
        row.controls['valorTotalLiquido'].setValue(
          row.controls['valorUnitarioLiquido'].value * row.controls['qtde'].value
        );
        console.log('valorUnitarioLiquido>>>>>>>' + row.controls['valorUnitarioLiquido'].value);
        console.log('valorTotalLiquido>>>>>>>' + row.controls['valorTotalLiquido'].value);
      }
    }
  }

  changeDescPercUnitario(row: FormGroup) {
    row.controls['descValorUnitario'].setValue(
      (row.controls['valorUnitario'].value * row.controls['descPercUnitario'].value) / 100
    );
    row.controls['valorUnitarioLiquido'].setValue(
      row.controls['valorUnitario'].value - row.controls['descValorUnitario'].value
    );
    row.controls['valorTotalLiquido'].setValue(
      row.controls['valorUnitarioLiquido'].value * row.controls['qtde'].value
    );
    if (!row.controls['icmsDigitacaomanual'].value) {
      row.controls['icmsBasecalculo'].setValue(
        row.controls['valorUnitarioLiquido'].value * row.controls['qtde'].value
      );
    }
    row.controls['icmsBasecalculo'].setValue(
      row.controls['valorUnitarioLiquido'].value * row.controls['qtde'].value
    );
  }

  changedescValorUnitario(row: FormGroup) {
    row.controls['descPercUnitario'].setValue(
      (row.controls['descValorUnitario'].value / row.controls['valorUnitario'].value) * 100
    );
    row.controls['valorUnitarioLiquido'].setValue(
      row.controls['valorUnitario'].value - row.controls['descValorUnitario'].value
    );
    row.controls['valorTotalLiquido'].setValue(
      row.controls['valorUnitarioLiquido'].value * row.controls['qtde'].value
    );
    if (!row.controls['icmsDigitacaomanual'].value) {
      row.controls['icmsBasecalculo'].setValue(
        row.controls['valorUnitarioLiquido'].value * row.controls['qtde'].value
      );
    }
  }

  enterPressedOnIcmsBaseCalculo(row: FormGroup) {
    console.log('enterPressedOnIcmsBaseCalculo');
  }

  selectIcmsBaseCalculo(event: any) {
    console.log('selectIcmsBaseCalculo');
  }

  selectIpiValor(event: any) {
    console.log('selectIpiValor');
  }

  changeIcmsPercentual(row: FormGroup) {
    row.controls['icmsValor'].setValue(
      (row.controls['icmsBasecalculo'].value * row.controls['icmsPerc'].value) / 100
    );
  }

  changeIpiPercentual(row: FormGroup) {
    console.log('changeIpiPercentual' + row.controls['valorTotalLiquido'].value);
    row.controls['ipiValor'].setValue(
      (row.controls['valorTotalLiquido'].value * row.controls['ipiPercentual'].value) / 100
    );
  }

  incluirDoctoI(item: FatDoctoI, qtde = 1, persistNow = false) {
    console.log('incluirDoctoI');
    const produto = this.produto;
    console.log(`produto>>>>>>: ${JSON.stringify(produto)}`);

    if (produto === undefined || produto === null) {
      this.confirmService.confirm({
        message: `Produto Não Selecionado. Selecione um Produto e Click em Adicionar Item !!`,
        error: true,
      });
      return;
    }

    const ctrl = this.doctoCForm?.value?.controle;

    if (ctrl === undefined || ctrl === null || ctrl === 0) {
      this.confirmService.confirm({
        message: `Por favor, salve o lançamento e clique em Adicionar Item !!`,
        error: true,
      });
      return;
    }

    const existingIndex = this.findExistingItemIndexByProdutoId(produto?.id);
    if (existingIndex >= 0) {
      this.produtoItemExists$.next(true);

      if (persistNow) {
        this.incrementExistingItemQtyByProductId(produto.id, qtde);
        return;
      }

      this.editExistingSelectedProdutoItem();
      return;
    }

    this.doctoCForm.patchValue({ produtoSearch: '' });

    // if (!this.produto || !Array.isArray(this.produto.precos)) {
    //   this.confirmService.confirm({
    //     preco.tabelaId === this.doctoCForm.value.fatListaPrecoTabela?.id?.tabelaId &&
    //     preco.listaId === this.doctoCForm.value.fatListaPreco?.id
    //   });
    //   return;
    // }
    // if (!this.produto || !Array.isArray(this.produto.precos)) {
    //   this.confirmService.confirm({
    //     message: `Produto sem preços cadastrados. Verifique o cadastro do produto!`,
    //     error: true,
    //   });
    //   return;
    // }
    // console.log('precoPadrao>>>>>>>' + JSON.stringify(this.precoPadrao))
    // this.precoPadrao = this.produto.precos.filter(
    //   (preco) =>
    //     preco.tabelaId === this.doctoCForm.value.fatListaPrecoTabela.id.tabelaId &&
    //     preco.listaId === this.doctoCForm.value.fatListaPreco.id
    // );



    // item = {} as FatDoctoI;
    // item.id = {} as ItemID;
    // item.id.fatProduto = produto;
    // item.id.fatDoctoCControle = this.lcto.controle;
    // item.qtde = 1;
    // item.valorUnitario = this.precoPadrao[0]?.preco ?? 0;
    // item.valorTotal = this.precoPadrao[0]?.preco ?? 0;
    // item.descPercUnitario = 0.000;
    // item.descValorUnitario = 0.0;


    const tabelaId =
      this.doctoCForm.value?.fatListaPrecoTabela?.id?.tabelaId ??
      this.doctoCForm.value?.fatListaPrecoTabela?.tabelaId ??
      this.doctoCForm.value?.fatListaPrecoTabela ??
      null;

    const listaId =
      this.doctoCForm.value?.fatListaPreco?.id ??
      this.doctoCForm.value?.fatListaPreco?.listaId ??
      this.doctoCForm.value?.fatListaPreco ??
      null;

    // função utilitária para obter custos a partir do produto
    const getProdutoCost = (produto: any, key: string) => {
      // tenta primeiro em fatProdutoSaldo, depois no topo do produto e por fim 0
      const saldo = produto?.fatProdutoSaldo;
      if (key === 'custoReal') return saldo?.custoReal ?? (produto as any).custoReal ?? (produto as any).custoMedio ?? 0;
      if (key === 'custoMedio') return (produto as any).custoMedio ?? saldo?.custoMedio ?? (produto as any).custoReal ?? 0;
      if (key === 'custoNfe') return saldo?.custoNfe ?? saldo?.custoDigitado ?? (produto as any).custoMedio ?? 0;
      return 0;
    };

    // se tabela corresponde a tipos especiais (1001..1004) pega custo específico
    let chosenPrice = null;
    const tabelaKey = tabelaId != null ? String(tabelaId) : null;
    if (tabelaKey === '1001' || tabelaKey === '1003') {
      // 1001 ou 1003 => custo real/reposicao 
      chosenPrice = getProdutoCost(this.produto, 'custoReal');
      this.precoPadrao = [{ preco: chosenPrice, source: 'custoReal' }];
    } else if (tabelaKey === '1004') {
      // 1004 => custo medio (customediro)
      chosenPrice = getProdutoCost(this.produto, 'custoMedio');
      this.precoPadrao = [{ preco: chosenPrice, source: 'custoMedio' }];
    } else if (tabelaKey === '1002') {
      // 1002 => custo NFE (ou fallback)
      chosenPrice = getProdutoCost(this.produto, 'custoNfe');
      this.precoPadrao = [{ preco: chosenPrice, source: 'custoNfe' }];
    } else {
      // busca na lista de preços conforme tabela/lista selecionada no lançamento
      if (!this.produto || !Array.isArray(this.produto.precos)) {
        this.precoPadrao = [];
      } else {
        this.precoPadrao = this.produto.precos.filter((preco: any) => {
          const pTabela = preco.tabelaId ?? preco.tabela?.id ?? preco.tabela?.id?.tabelaId ?? null;
          const pLista = preco.listaId ?? preco.lista ?? preco.listaPreco?.id ?? null;
          const tabelaOk = tabelaId == null ? true : pTabela === tabelaId;
          const listaOk = listaId == null ? true : pLista === listaId;
          return tabelaOk && listaOk;
        });
        // se não encontrou, tenta casar somente por tabela, depois usa primeiro preço disponível
        if (!this.precoPadrao || this.precoPadrao.length === 0) {
          this.precoPadrao = this.produto.precos.filter((preco: any) => {
            const pTabela = preco.tabelaId ?? preco.tabela?.id ?? preco.tabela?.id?.tabelaId ?? null;
            return tabelaId == null ? false : pTabela === tabelaId;
          });
        }
        if (!this.precoPadrao || this.precoPadrao.length === 0) {
          // fallback geral: usar campo preco do produto ou primeiro preco da lista
          const fallback = (this.produto?.preco ?? this.produto?.precos?.[0]?.preco ?? 0);
          this.precoPadrao = [{ preco: fallback, source: 'fallback' }];
        }
      }
    }

    // assegura que precoPadrao está definido e extrai valor numérico seguro
    const unitPrice = Number(this.precoPadrao?.[0]?.preco ?? 0);

    item = {} as FatDoctoI;
    item.id = {} as ItemID;
    item.id.fatProduto = produto;
    item.id.fatDoctoCControle = this.lcto.controle;
    const qty = Number(qtde || 1);
    item.qtde = qty > 0 ? qty : 1;
    item.valorUnitario = unitPrice;
    item.valorTotal = unitPrice * item.qtde;
    item.descPercUnitario = 0.000;
    item.descValorUnitario = 0.0;


    this.zone.run(() => {
      const currentItems = this.doctoIs$.value || [];
      this.doctoIs$.next([...currentItems, item]);
    });

    this.reloadFormItens();
    this.scrollItemsToEnd();

    const targetIndex = Math.max(0, this.itemFormArray.length - 1);

    if (persistNow) {
      this.requestBarcodePersist();
    } else if (!this.layoutConf.isMobile) {
      // Mantém foco previsível na linha recém inserida, evitando ficar em linhas já abertas.
      this.isEditableDoctI = {};
      this.isEditableParcela = {};
      this.isEditableDoctI[targetIndex] = true;
      this.isEditableParcela[targetIndex] = true;
      this.cdr.detectChanges();
      this.ngxDatatable?.recalculate();
      this.focusAddedItemQtdeInput(targetIndex);
    } else {
      this.save(false, false);
      this.editDoctoI(item, targetIndex, targetIndex);
    }

    if (!persistNow && this.layoutConf?.isMobile) {
      setTimeout(() => this.focusBarcodeInputByDevice(), 80);
    }
  }

  private focusAddedItemQtdeInput(controlIndex?: number) {
    const focusTargetQtdeInput = () => {
      let input: HTMLInputElement | null = null;

      if (!input && controlIndex != null) {
        input = document.querySelector(
          `.custom-datatable input[name="qtde"][data-control-index="${controlIndex}"]`
        ) as HTMLInputElement | null;
      }

      if (!input && controlIndex == null) {
        const inputs = Array.from(document.querySelectorAll('.custom-datatable input[name="qtde"]')) as HTMLInputElement[];
        input = inputs.length > 0 ? inputs[inputs.length - 1] : null;
      }

      if (!input) {
        return false;
      }

      input.focus();
      input.select();

      // Alguns browsers/directives não mantêm o select() na primeira chamada.
      const valueLength = input.value?.length ?? 0;
      if (valueLength > 0) {
        input.setSelectionRange(0, valueLength);
      }

      return document.activeElement === input;
    };

    const ensureTargetRowInEditMode = () => {
      if (controlIndex == null) {
        return;
      }

      const targetEditButton = document.querySelector(
        `.custom-datatable button.green-button[data-control-index="${controlIndex}"]`
      ) as HTMLButtonElement | null;

      if (targetEditButton) {
        targetEditButton.click();
      }
    };

    const maxAttempts = 12;
    let attempts = 0;

    const runAttempt = () => {
      attempts += 1;

      // Garante renderização da linha alvo no viewport da datatable virtualizada.
      this.scrollItemsToIndex(controlIndex);

      const focused = focusTargetQtdeInput();
      if (focused || attempts >= maxAttempts) {
        return;
      }

      if (attempts === 2) {
        ensureTargetRowInEditMode();
      }

      setTimeout(runAttempt, 90);
    };

    setTimeout(runAttempt, 50);
  }

  private scrollItemsToIndex(index?: number) {
    if (this.layoutConf?.isMobile) {
      this.scrollItemsToEnd();
      return;
    }

    const desktopScroll =
      (document.querySelector('.custom-datatable .datatable-body .datatable-scroll') as HTMLElement | null) ||
      (document.querySelector('.custom-datatable .datatable-body') as HTMLElement | null);

    if (!desktopScroll) {
      return;
    }

    if (index == null || index < 0) {
      desktopScroll.scrollTop = desktopScroll.scrollHeight;
      return;
    }

    const rowHeight = 54;
    const viewportHeight = Math.max(0, desktopScroll.clientHeight);
    const targetTop = Math.max(0, (index * rowHeight) - (viewportHeight - rowHeight));
    desktopScroll.scrollTop = targetTop;
  }

  private scrollItemsToEnd() {
    setTimeout(() => {
      if (this.layoutConf?.isMobile) {
        const mobileScroll = this.mobileItemsScrollRef?.nativeElement;
        if (mobileScroll) {
          mobileScroll.scrollTop = mobileScroll.scrollHeight;
        }
        return;
      }

      const desktopScroll =
        (document.querySelector('.custom-datatable .datatable-body .datatable-scroll') as HTMLElement | null) ||
        (document.querySelector('.custom-datatable .datatable-body') as HTMLElement | null);
      if (desktopScroll) {
        desktopScroll.scrollTop = desktopScroll.scrollHeight;
      }
    }, 40);
  }

  private scrollItemsToStart() {
    setTimeout(() => {
      if (this.layoutConf?.isMobile) {
        const mobileScroll = this.mobileItemsScrollRef?.nativeElement;
        if (mobileScroll) {
          mobileScroll.scrollTop = 0;
        }
        return;
      }

      const desktopScroll =
        (document.querySelector('.custom-datatable .datatable-body .datatable-scroll') as HTMLElement | null) ||
        (document.querySelector('.custom-datatable .datatable-body') as HTMLElement | null);
      if (desktopScroll) {
        desktopScroll.scrollTop = 0;
      }
    }, 40);
  }

  getPageItem(page: number, pageSize: number, controle: number) {
    if (controle !== undefined) {
      this.fatDoctoCService
        .getPageItem(this.lcto?.controle, page, pageSize, this.selectedItemOrdem, this.selectedItemDirect)
        .subscribe(
          (val) => {
            this.pageObjectDoctoI$.next(val);
            this.loader.close();
          },
          (err) => {
            this.loader.close();
            this.confirmService.confirm({
              title: 'ERRO AO PESQUISAR ITENS',
              message: err.error.status,
              error: true,
            });
          }
        );
    }
  }

  reloadPageItem() {
    this.pageItem = 1;
    this.getPageItem(this.pageItem, this.pageSizeItem, this.lcto?.controle);
  }

  getSearchPageItem(search: string, page: number, pageSize: number) {
    if (page === 1) {
      this.paginatorItem.firstPage();
    }
    if (search === null || search === undefined || search.length === 0) {
      this.getPageItem(1, this.pageSizeItem, this.lcto?.controle);
    } else {
      this.fatDoctoCService
        .getPageItemSearch(this.lcto?.controle, page, pageSize, search, this.selectedItemOrdem, this.selectedItemDirect)
        .subscribe((val) => {
          this.pageObjectDoctoI$.next(val);
        });
    }
  }

  setPageSizeOptionsItem(event: PageEvent) {
    console.log('setPageSizeOptionsItem');
    console.log(`event.pageSize ${event.pageSize}`);
    this.pageSizeItem = event.pageSize;
    if (this.itemFormArray.dirty) {
      this.save();
    }
    if (this.searchInput.length > 0) {
      this.getSearchPageItem(this.searchInput, event.pageIndex + 1, event.pageSize);
    } else {
      this.getPageItem(event.pageIndex + 1, event.pageSize, this.lcto?.controle);
    }
  }

  searchBy_UsingDebounceItem(searchString: any) {
    this.searchInput = searchString;
    this.searchEntry$.next(this.searchInput);
  }

  debounceTimeSearchItem() {
    this.searchEntry$.pipe(debounceTime(250)).subscribe((s) => this.getSearchPageItem(s, 1, this.pageSizeItem));
  }

  askToSave() {
    this.confirmService.confirm({ message: `Salvar Lançamento?` }).subscribe((res) => {
      if (res) {
      }
    });
  }

  deleteDoctoI(row: any) {
    this.confirmService
      .confirm({ message: `Deletar ${row?.id.fatProduto.codigo + '-' + row?.id.fatProduto.descricao}?` })
      .subscribe((res) => {
        if (res) {
          setTimeout(() => (this.isEditableDoctI = {}), 300);
          this.fatDoctoCService.deleteItem(this.lcto?.controle, row.id.fatProduto.id).subscribe(
            (data2) => {
              this.loader.close();
              this.reloadPageItem();
              this.confirmService.confirm({
                title: !data2.erro ? 'Sucesso' : 'Erro',
                message: data2.status,
                error: true,
              });
              if (!data2.erro) {
                this.getPageItem(
                  this.pageObjectDoctoI$?.value?.content.length > 1 ? this.pageItem : this.pageItem - 1,
                  this.pageSizeItem,
                  this.lcto?.controle
                );
              }
            },
            (err) => {
              this.loader.close();
              this.reloadPageItem();
            }
          );
        }
      });
  }

  onFocusProduto(event: FocusEvent) {
    this.doctoCForm
      .get('produtoSearch')
      .valueChanges.pipe(
        debounceTime(100),
        tap(() => (this.searching = true)),
        switchMap((value) =>
          typeof value === 'string'
            ? value !== undefined && value !== ''
              ? this.produtoService.getProdutoPageSearch(1, 30, value, 'NENHUM', 'ASC', false, false, PRODUTO_TIPOS_COM_DESPESA)
              : this.produtoService.getProdutoPage(1, 30, 'NENHUM', 'ASC', true, undefined, PRODUTO_TIPOS_COM_DESPESA)
            : new Observable<PageResult<Produto>>()
        ),
        finalize(() => (this.searching = false))
      )
      .subscribe((produtos) => this.produtos$.next(produtos.content));
  }

  onSelectionChangeProduto(event: any): void {
    if (event.value !== undefined) {
      this.produto = event.value;
      this.fatDoctoCService.getExistsItem(this.lcto?.controle, this.produto.id).subscribe((val) =>
        this.produtoItemExists$.next(val)
      );
    }
  }

  private findExistingItemIndexByProdutoId(produtoId: number | undefined | null): number {
    if (!produtoId) {
      return -1;
    }

    return this.itemFormArray?.controls?.findIndex((ctrl: any) => ctrl?.value?.id?.fatProduto?.id === produtoId) ?? -1;
  }

  editExistingSelectedProdutoItem() {
    const produtoId = this.produto?.id;
    if (!produtoId) {
      this.confirmService.confirm({
        message: `Selecione um produto para editar o item existente.`,
        error: true,
      });
      return;
    }

    const idx = this.findExistingItemIndexByProdutoId(produtoId);
    if (idx < 0) {
      this.confirmService.confirm({
        message: `Item do produto selecionado não encontrado no lançamento.`,
        error: true,
      });
      return;
    }

    // Desktop: keep same inline edit flow as the datatable row edit button.
    if (!this.layoutConf?.isMobile) {
      this.isEditableDoctI[idx] = true;
      this.isEditableParcela[idx] = true;

      setTimeout(() => {
        const input = document.querySelector('.ngx-datatable input[name="qtde"]') as HTMLInputElement | null;
        if (input) {
          input.focus();
          input.select();
        }
      }, 50);
      return;
    }

    // Mobile: keep popup details flow.
    const row = (this.itemFormArray.at(idx) as FormGroup)?.value;
    this.editDoctoI(row, idx, idx);
  }

  focusMobileBarcodeInput() {
    const input = this.mobileBarcodeInputRef?.nativeElement;
    if (!input) {
      return;
    }
    input.focus();
    input.select();
  }

  focusDesktopBarcodeInput() {
    const input = this.desktopBarcodeInputRef?.nativeElement;
    if (!input) {
      return;
    }
    input.focus();
    input.select();
  }

  private focusBarcodeInputByDevice() {
    if (this.layoutConf?.isMobile) {
      this.focusMobileBarcodeInput();
      return;
    }
    this.focusDesktopBarcodeInput();
  }

  onBarcodePrimaryAction() {
    if (this.shouldUseCameraScanner()) {
      this.mobileManualBarcodeInput = false;
      this.blurActiveElement();
      this.openMobileBarcodeCamera();
      return;
    }

    this.addItemByBarcodeMobile();
  }

  private shouldUseCameraScanner(): boolean {
    if (this.layoutConf?.isMobile) {
      return true;
    }

    const ua = (navigator?.userAgent || '').toLowerCase();
    const byUa = /android|iphone|ipad|ipod|iemobile|opera mini/.test(ua);
    const byTouch = (navigator?.maxTouchPoints || 0) > 1 && window.innerWidth <= 1024;
    return byUa || byTouch;
  }

  async openMobileBarcodeCamera() {
    this.mobileManualBarcodeInput = false;
    this.blurActiveElement();

    if (!this.shouldUseCameraScanner()) {
      this.addItemByBarcodeMobile();
      return;
    }

    if (this.mobileCameraScanning) {
      this.stopMobileBarcodeCamera();
      return;
    }

    const barcodeDetectorCtor = (window as any)?.BarcodeDetector;
    if (!barcodeDetectorCtor) {
      this.confirmService.confirm({
        message: `Leitura por câmera não suportada neste navegador. Use Chrome/Edge no celular ou leitor por teclado.`,
        error: true,
      });
      return;
    }

    if (!navigator?.mediaDevices?.getUserMedia) {
      this.confirmService.confirm({
        message: `Câmera indisponível neste ambiente.`,
        error: true,
      });
      return;
    }

    try {
      this.mobileScannerStream = await navigator.mediaDevices.getUserMedia({
        video: {
          facingMode: { ideal: 'environment' },
        },
        audio: false,
      });

      this.mobileCameraScanning = true;
      this.cdr.detectChanges();

      const video = this.mobileBarcodeVideoRef?.nativeElement;
      if (!video) {
        this.stopMobileBarcodeCamera();
        return;
      }

      video.srcObject = this.mobileScannerStream;
      await video.play();
      this.startMobileBarcodeDetectLoop();
    } catch (err) {
      this.stopMobileBarcodeCamera();
      this.confirmService.confirm({
        message: `Não foi possível abrir a câmera. Verifique permissão no navegador.`,
        error: true,
      });
    }
  }

  private blurActiveElement() {
    const active = document?.activeElement as HTMLElement;
    if (active && typeof active.blur === 'function') {
      active.blur();
    }
  }

  toggleMobileManualBarcodeInput() {
    this.mobileManualBarcodeInput = !this.mobileManualBarcodeInput;
    if (this.mobileManualBarcodeInput) {
      setTimeout(() => this.focusMobileBarcodeInput(), 60);
      return;
    }
    this.blurActiveElement();
  }

  stopMobileBarcodeCamera() {
    if (this.mobileScannerIntervalId != null) {
      window.clearInterval(this.mobileScannerIntervalId);
      this.mobileScannerIntervalId = null;
    }

    const video = this.mobileBarcodeVideoRef?.nativeElement;
    if (video) {
      try {
        video.pause();
      } catch (_) {
      }
      video.srcObject = null;
    }

    if (this.mobileScannerStream) {
      this.mobileScannerStream.getTracks().forEach((track) => track.stop());
      this.mobileScannerStream = null;
    }

    this.mobileCameraBusy = false;
    this.mobileCameraScanning = false;
  }

  private startMobileBarcodeDetectLoop() {
    const barcodeDetectorCtor = (window as any)?.BarcodeDetector;
    if (!barcodeDetectorCtor) {
      return;
    }

    const detector = new barcodeDetectorCtor({
      formats: ['ean_13', 'ean_8', 'code_128', 'code_39', 'upc_a', 'upc_e', 'itf', 'codabar', 'qr_code'],
    });

    this.mobileScannerIntervalId = window.setInterval(async () => {
      if (!this.mobileCameraScanning || this.mobileCameraBusy) {
        return;
      }

      const video = this.mobileBarcodeVideoRef?.nativeElement;
      if (!video || video.readyState < 2) {
        return;
      }

      this.mobileCameraBusy = true;
      try {
        const found = await detector.detect(video);
        const rawValue = found?.[0]?.rawValue ? String(found[0].rawValue).trim() : '';
        if (rawValue) {
          this.mobileBarcodeInput = rawValue;
          this.stopMobileBarcodeCamera();
          this.addItemByBarcodeMobile();
        }
      } catch (_) {
      } finally {
        this.mobileCameraBusy = false;
      }
    }, 300);
  }

  addItemByBarcodeMobile() {
    const raw = (this.mobileBarcodeInput || '').toString().trim();
    if (!raw) {
      return;
    }

    this.mobileBarcodeInput = '';
    this.enqueueBarcodeScan(raw);
  }

  private enqueueBarcodeScan(rawCode: string) {
    const raw = (rawCode || '').toString().trim();
    if (!raw) {
      return;
    }

    this.barcodeScanQueue.push(raw);
    this.processNextBarcodeScan();
  }

  private processNextBarcodeScan() {
    if (this.barcodeScanProcessing || this.mobileBarcodeSearching) {
      return;
    }

    const nextRaw = this.barcodeScanQueue.shift();
    if (!nextRaw) {
      return;
    }

    this.barcodeScanProcessing = true;
    this.processBarcodeScan(nextRaw, () => {
      this.barcodeScanProcessing = false;
      if (this.barcodeScanQueue.length > 0) {
        setTimeout(() => this.processNextBarcodeScan(), 0);
      }
    });
  }

  private processBarcodeScan(raw: string, done: () => void) {
    const finish = () => {
      done();
    };

    const payload = this.parseBarcodePayload(raw);
    const normalized = payload.code;
    const onlyDigits = normalized.replace(/\D+/g, '');
    const candidates = this.buildBarcodeSearchCandidates(normalized, onlyDigits);
    const qtyToAdd = payload.qty;
    const lctoControle = this.lcto?.controle ?? 0;
    if (!lctoControle) {
      this.confirmService.confirm({
        message: `Por favor, salve o lançamento e tente novamente.`,
        error: true,
      });
      finish();
      return;
    }

    this.mobileBarcodeSearching = true;
    const tryCandidate = (idx: number) => {
      if (idx >= candidates.length) {
        this.mobileBarcodeSearching = false;
        this.confirmService.confirm({
          message: `Produto não encontrado para o código [${raw}].`,
          error: true,
        });
        finish();
        return;
      }

      const candidate = candidates[idx];
      const candidateDigits = candidate.replace(/\D+/g, '');
      this.produtoService.getProdutoByBarcode(candidate).subscribe(
        (produtos) => {
          const match = this.pickProdutoFromBarcode(produtos, candidate, candidateDigits);

          if (!match) {
            // Verificar se há múltiplos produtos com mesmo código de barras
            const exactMatches = this.filterExactBarcodeMatches(produtos, candidate, candidateDigits);
            if (exactMatches.length > 1) {
              this.showBarcodeSelectionDialog(exactMatches, qtyToAdd, lctoControle, finish);
              return;
            }
            tryCandidate(idx + 1);
            return;
          }

          this.produto = match;

          // Prefer local increment to keep scanner flow responsive and avoid remote lock race.
          const incrementedLocal = this.incrementExistingItemQtyByProductId(this.produto.id, qtyToAdd);
          if (incrementedLocal) {
            this.mobileBarcodeSearching = false;
            this.produtoItemExists$.next(true);
            this.focusBarcodeInputByDevice();
            finish();
            return;
          }

          this.fatDoctoCService.getExistsItem(lctoControle, this.produto.id).subscribe(
            (exists) => {
              this.produtoItemExists$.next(exists);
              this.mobileBarcodeSearching = false;

              if (exists) {
                const incremented = this.incrementExistingItemQtyByProductId(this.produto.id, qtyToAdd);
                if (!incremented) {
                  this.confirmService.confirm({
                    message: `Produto já existe no lançamento.`,
                    error: true,
                  });
                }
                this.focusBarcodeInputByDevice();
                finish();
                return;
              }

              this.incluirDoctoI(this.newItem, qtyToAdd, true);
              setTimeout(() => this.focusBarcodeInputByDevice(), 60);
              finish();
            },
            () => {
              this.mobileBarcodeSearching = false;
              this.confirmService.confirm({
                message: `Erro ao verificar item existente por código de barras.`,
                error: true,
              });
              finish();
            }
          );
        },
        () => {
          this.mobileBarcodeSearching = false;
          this.confirmService.confirm({
            message: `Erro ao pesquisar produto por código de barras.`,
            error: true,
          });
          finish();
        }
      );
    };

    tryCandidate(0);
  }

  private buildBarcodeSearchCandidates(normalizedCode: string, digitsOnly: string): string[] {
    const candidates: string[] = [];
    const add = (value: string) => {
      const v = (value || '').trim();
      if (!v || candidates.includes(v)) {
        return;
      }
      candidates.push(v);
    };

    add(normalizedCode);
    add(digitsOnly);
    if (/^\d+$/.test(digitsOnly)) {
      add(digitsOnly.replace(/^0+/, ''));
    }

    return candidates;
  }

  private incrementExistingItemQtyByProductId(produtoId: number, qtyAdd = 1): boolean {
    const idx = this.itemFormArray?.controls?.findIndex((ctrl: any) => ctrl?.value?.id?.fatProduto?.id === produtoId);
    if (idx == null || idx < 0) {
      return false;
    }

    const row = this.itemFormArray.at(idx) as FormGroup;
    const atual = Number(row.controls['qtde']?.value || 0);
    const qty = Number(qtyAdd || 1);
    const incremento = qty > 0 ? qty : 1;
    row.controls['qtde'].setValue(atual + incremento);
    this.changeQtdeOrValorUnitario(row);
    this.requestBarcodePersist();
    this.snack.open(`Quantidade incrementada (+${incremento}) no item existente.`, 'OK', { duration: 1800 });
    return true;
  }

  private parseBarcodePayload(rawInput: string): { code: string; qty: number } {
    const normalized = (rawInput || '').replace(/\s+/g, '');
    const match = normalized.match(/^(.*?)(?:[xX\*](\d+))?$/);
    const code = (match?.[1] || normalized).trim();
    const parsedQty = Number(match?.[2] || 1);
    const qty = Number.isFinite(parsedQty) && parsedQty > 0 ? parsedQty : 1;
    return { code, qty };
  }

  private pickProdutoFromBarcode(produtos: Produto[], rawCode: string, digitsOnly: string): Produto | null {
    if (!produtos?.length) {
      return null;
    }

    const raw = (rawCode || '').trim();
    const digits = (digitsOnly || '').trim();
    const exactMatches = this.filterExactBarcodeMatches(produtos, raw, digits);

    if (exactMatches.length === 1) {
      return exactMatches[0];
    }

    // Se múltiplos matches, retorna null para que processBarcodeScan trate
    if (exactMatches.length > 1) {
      return null;
    }

    // Sem match exato por barcode — usa o primeiro retornado pela busca
    return produtos[0] || null;
  }

  private filterExactBarcodeMatches(produtos: Produto[], rawCode: string, digitsOnly: string): Produto[] {
    const raw = (rawCode || '').trim();
    const digits = (digitsOnly || '').trim();
    return produtos.filter((p) => {
      const values = [
        p?.codigo,
        (p as any)?.codigobarra1,
        (p as any)?.codigobarra2,
        (p as any)?.codigobarra3,
        (p as any)?.codigobarra4,
        (p as any)?.codigoBarraBalanca,
      ];

      return values.some((val) => {
        const code = String(val ?? '').trim();
        if (!code) {
          return false;
        }
        const codeDigits = code.replace(/\D+/g, '');
        return code === raw || (digits.length > 0 && codeDigits === digits);
      });
    });
  }

  private showBarcodeSelectionDialog(produtos: Produto[], qtyToAdd: number, lctoControle: number, finish: () => void) {
    this.mobileBarcodeSearching = false;
    const dialogRef = this.dialog.open(BarcodeSelectionDialogComponent, {
      width: this.layout.isMobile ? '100%' : '620px',
      maxWidth: this.layout.isMobile ? '100vw' : '96vw',
      disableClose: false,
      data: { produtos },
    });

    dialogRef.afterClosed().subscribe((selected: Produto | null) => {
      if (!selected) {
        this.focusBarcodeInputByDevice();
        finish();
        return;
      }

      this.produto = selected;

      const incrementedLocal = this.incrementExistingItemQtyByProductId(this.produto.id, qtyToAdd);
      if (incrementedLocal) {
        this.produtoItemExists$.next(true);
        this.focusBarcodeInputByDevice();
        finish();
        return;
      }

      this.fatDoctoCService.getExistsItem(lctoControle, this.produto.id).subscribe(
        (exists) => {
          this.produtoItemExists$.next(exists);
          if (exists) {
            const incremented = this.incrementExistingItemQtyByProductId(this.produto.id, qtyToAdd);
            if (!incremented) {
              this.confirmService.confirm({
                message: `Produto já existe no lançamento.`,
                error: true,
              });
            }
            this.focusBarcodeInputByDevice();
            finish();
            return;
          }
          this.incluirDoctoI(this.newItem, qtyToAdd, true);
          setTimeout(() => this.focusBarcodeInputByDevice(), 60);
          finish();
        },
        () => {
          this.confirmService.confirm({
            message: `Erro ao verificar item existente por código de barras.`,
            error: true,
          });
          finish();
        }
      );
    });
  }

  displayFnProduto(prod: Produto) {
    if (prod) {
      return `${prod.codigo.toString().padStart(6, '0')} - ${prod.descricao.trim()}`;
    }
  }

  private initLogItens() {
    this.it = 0;
    this.workDone = null;
    this.max = null;
  }

  save(previa = false, mostrarOk = true): BehaviorSubject<FatDoctoC> {
    const result = new BehaviorSubject<FatDoctoC>({} as FatDoctoC);
    const obs = new BehaviorSubject<Log>({} as Log);
    this.saveItem = true;
    this.openProgressLoader(obs);
    this.fatDoctoCService.saveOrUpdate(this.doctoCForm.value).subscribe(
      (val) => {
        this.reloadLctoItens(val);
        this.getPageItem(1, this.pageSizeItem, val.controle);
        console.log(val);
        this.deleteLog();
        if (!previa) {
          if (mostrarOk) {
            this.snack.open(`SALVO COM SUCESSO!`, 'OK', { duration: 5500 });
            this.confirmService.confirm({
              title: 'SALVAR',
              message: 'OK, Lançamento Salvo com Sucesso!',
              error: false,
            });
          }
        }
        this.isEditableDoctI = {};
        this.isEditableParcela = {};
        if (!this.barcodePersistRequested && this.barcodeScanQueue.length === 0 && !this.barcodeScanProcessing) {
          this.barcodeAutoModeActive = false;
        }
        result.next(val);
        this.saveItem = false;
      },
      (err) => {
        this.deleteLog();
        result.error(err);
        this.saveItem = false;

        if (this.barcodeAutoModeActive && this.isLctoLockedError(err)) {
          this.requestBarcodePersist();
          this.snack.open('Lançamento em processamento. Nova tentativa automática de salvar...', 'OK', {
            duration: 1800,
          });
          return;
        }

        this.snack.open(`ERRO:${err.error.status}!`, 'ERRO', { duration: 5500 });
        this.confirmService.confirm({
          title: 'ERRO AO SALVAR, VERIFIQUE',
          message: err.error.status,
          error: true,
        });
      }
    );
    return result;
  }

  fixaPesoBruto() {
    this.doctoCForm.controls['fixaPesoBruto'].patchValue(true);
  }

  fixaPesoLiquido() {
    this.doctoCForm.controls['fixaPesoLiquido'].patchValue(true);
  }

  fixaVolumes() {
    this.doctoCForm.controls['fixaVolumes'].patchValue(true);
  }

  changeDescPerc() {
    const descPerc = this.doctoCForm.controls['descontodoctoPerc'].value;
    const totalProdutos = this.doctoCForm.controls['totalprodutos'].value;
    if (descPerc === 0) {
      this.doctoCForm.controls['descontodoctoPerc'].patchValue(0);
      this.doctoCForm.controls['descontodoctoValor'].patchValue(0);
    } else if (descPerc <= 100) {
      const descValor = totalProdutos * (descPerc / 100);
      this.doctoCForm.controls['descontodoctoValor'].patchValue(descValor);
    } else {
      this.confirmService.confirm({
        title: 'A T E N Ç Ã O !',
        message: 'Valor desconto: ' + descPerc + ' maior que 100% , VERIFIQUE!',
        error: true,
      });
      this.doctoCForm.controls['descontodoctoValor'].patchValue(0);
      this.doctoCForm.controls['descontodoctoPerc'].patchValue(0);
      return;
    }
    this.recalcTotal();
  }

  changeDescValor() {
    const descValor = this.doctoCForm.controls['descontodoctoValor'].value;
    const totalProdutos = this.doctoCForm.controls['totalprodutos'].value;
    this.doctoCForm.controls['descontodoctoPerc'].patchValue(0);
    if (descValor === 0) {
      this.doctoCForm.controls['descontodoctoPerc'].patchValue(0);
    } else if (descValor <= totalProdutos) {
      const result = ((totalProdutos - (totalProdutos - descValor)) * 100) / totalProdutos;
      this.doctoCForm.controls['descontodoctoPerc'].patchValue(result);
    } else {
      this.confirmService.confirm({
        title: 'A T E N Ç Ã O !',
        message:
          'Valor desconto: ' + descValor + ' maior que o Total dos produtos:' + totalProdutos + 'VERIFIQUE!',
        error: true,
      });
      this.doctoCForm.controls['descontodoctoValor'].patchValue(0);
      return;
    }
    this.recalcTotal();
  }

  recalcTotal() {
    const totalliquidoprodutos = this.doctoCForm.controls['totalliquidoprodutos']?.value || 0;
    const freteValor = this.doctoCForm.controls['freteValor']?.value || 0;
    const despesaValor = this.doctoCForm.controls['despesaValor']?.value || 0;
    const ipiValor = this.doctoCForm.controls['ipiValor']?.value || 0;
    const icmssubstValor = this.doctoCForm.controls['icmssubstValor']?.value || 0;
    const seguroValor = this.doctoCForm.controls['seguroValor']?.value || 0;
    const icmsDesonValor = this.doctoCForm.controls['icmsDesonValor']?.value || 0;
    const descontodoctoValor = this.doctoCForm.controls['descontodoctoValor']?.value || 0;

    this.doctoCForm.controls['valortotalDocto'].patchValue(
      totalliquidoprodutos +
        freteValor +
        despesaValor +
        ipiValor +
        icmssubstValor +
        seguroValor -
        icmsDesonValor -
        descontodoctoValor
    );
  }

  submit() {
    if (this.doctoCForm.valid) {
      console.log('form submitted');
    } else {
      this.validateAllFormFields(this.doctoCForm);
    }
  }

  private deleteLog() {
    this.fatDoctoCService.deleteLog(this.lcto?.uuid).subscribe((log) => {
      this.progressLoader.close();
    });
  }

  private openProgressLoader(obs: BehaviorSubject<Log>) {
    this.progressLoader.open(obs);
    timer(1, 1500)
      .pipe(
        switchMap(() => this.fatDoctoCService.getLog(this.lcto?.uuid)),
        retry(),
        share(),
        takeUntil(this.stopPolling)
      )
      .subscribe(
        (valor) => {
          if (this.max === valor.max && this.workDone === valor.workDone) {
            this.it = this.it + 1;
          } else {
            this.it = 0;
          }
          this.max = valor.max;
          this.workDone = valor.workDone;
          if (
            (valor.workDone !== null &&
              valor.workDone !== undefined &&
              valor.max != null &&
              valor.max !== undefined &&
              valor.workDone >= valor.max) ||
            this.it === this.maxRetry
          ) {
            this.stopPolling.next();
            this.initLogItens();
          }
          obs.next(valor);
        },
        (err) => {
          this.loader.close();
          this.confirmService.confirm({
            title: 'ERRO AO EXECUTAR OPERAÇÃO',
            message: err.error.status,
            error: true,
          });
        }
      );
  }

  validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach((field) => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        console.log(field + ' - ' + control.valid);
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }

  isFieldValid(field: string) {
    return !this.doctoCForm.get(field)?.valid && this.doctoCForm.get(field)?.touched;
  }

  close() {
    this.dialogRef.close();
  }

  saveDoctoI(rowIndex: string) {
    this.isEditableDoctI[rowIndex] = !this.isEditableDoctI[rowIndex];
    this.save(false, false);
    this.reloadPageItem();
  }

  editDoctoIDI(row: any) {
    console.log('editDoctoIDI', row);
    let title = `ITEM: [  ${row?.id?.fatProduto?.codigo.toString().padStart(9, '0')} - ${
      row?.id?.fatProduto?.descricao
    } DI-Declaração(s) de Importação ]`;
    let dialogRef: MatDialogRef<any> = this.dialog.open(LancamentoItemDIListComponent, {
      width: this.layout.isMobile ? '100%' : '98%',
      disableClose: true,
      data: { title: title, payload: row },
    });

    dialogRef.afterClosed().subscribe((res) => {
      this.reloadPageItem();
      if (!res) {
        return;
      }
      this.reloadLctoItens(this.lcto);
    });
  }

  editDoctoI(row: any, captionIndex?: number, sourceIndex?: number) {
    console.log('editDoctoI', row);
    const itemNumber = (typeof captionIndex === 'number' ? captionIndex : 0) + 1;
    let title = `ITEM #${itemNumber}: [  ${row?.id?.fatProduto?.codigo.toString().padStart(9, '0')} - ${
      row?.id?.fatProduto?.descricao
    } ]`;
    let dialogRef: MatDialogRef<any> = this.dialog.open(LancamentoItemDetailsComponent, {
      width: this.layout.isMobile ? '100%' : '960px',
      maxWidth: this.layout.isMobile ? '100vw' : '96vw',
      height: this.layout.isMobile ? '100%' : '72vh',
      maxHeight: '100dvh',
      disableClose: true,
      data: { title: title, payload: row },
    });
    dialogRef.afterClosed().subscribe((res) => {
      if (res) {
        this.patchEditedItemInList(res, row, sourceIndex);
      }

      // Sempre recarrega ao fechar a edicao para refletir qualquer alteracao.
      this.reloadPageItem();
      // No mobile aplicamos segunda passada curta para cobrir latencia eventual de persistencia.
      if (this.layout.isMobile) {
        setTimeout(() => this.reloadPageItem(), 200);
      }
    });
  }

  private patchEditedItemInList(savedItem: any, originalRow: any, sourceIndex?: number) {
    const idx =
      typeof sourceIndex === 'number'
        ? sourceIndex
        : this.itemFormArray.controls.findIndex((ctrl: any) => {
            const row = ctrl?.value;
            return row?.id?.fatDoctoCControle === originalRow?.id?.fatDoctoCControle
              && row?.id?.fatProduto?.id === originalRow?.id?.fatProduto?.id;
          });

    if (idx < 0) {
      return;
    }

    const fg = this.itemFormArray.at(idx) as FormGroup;
    fg.patchValue({
      id: savedItem?.id,
      uuid: savedItem?.uuid,
      produto: savedItem?.id?.fatProduto,
      qtde: savedItem?.qtde,
      valorUnitario: savedItem?.valorUnitario,
      valorTotal: savedItem?.valorTotal,
      descPercUnitario: savedItem?.descPercUnitario,
      descValorUnitario: savedItem?.descValorUnitario,
      valorUnitarioLiquido: savedItem?.valorUnitarioLiquido,
      valorTotalLiquido: savedItem?.valorTotalLiquido,
      tabCfopId: savedItem?.tabCfopId,
      icmsClasstrib: savedItem?.icmsClasstrib,
      icmsDigitacaomanual: savedItem?.icmsDigitacaomanual,
      icmsBasecalculo: savedItem?.icmsBasecalculo,
      icmsPerc: savedItem?.icmsPerc,
      icmsValor: savedItem?.icmsValor,
      ipiDigitacaomanual: savedItem?.ipiDigitacaomanual,
      ipiPercentual: savedItem?.ipiPercentual,
      ipiValor: savedItem?.ipiValor,
      pisBasecalculo: savedItem?.pisBasecalculo,
      pisPerc: savedItem?.pisPerc,
      pisValor: savedItem?.pisValor,
      cofinsBasecalculo: savedItem?.cofinsBasecalculo,
      cofinsPerc: savedItem?.cofinsPerc,
      cofinsValor: savedItem?.cofinsValor,
      infAdProd: savedItem?.infAdProd,
      importacaoValorBaseCalculo: savedItem?.importacaoValorBaseCalculo,
      importacaoValorDespesaAduaneira: savedItem?.importacaoValorDespesaAduaneira,
      importacaoValorImpostoImportacao: savedItem?.importacaoValorImpostoImportacao,
      importacaoValorIOF: savedItem?.importacaoValorIOF,
      informaImpostoImportacao: savedItem?.informaImpostoImportacao,
      beneficioFiscal: savedItem?.beneficioFiscal,
      codigoBeneficioFiscalUF: savedItem?.codigoBeneficioFiscalUF,
      ibsCbsClasstrib: savedItem?.ibsCbsClasstrib,
      ibsCbsDigitacaoManual: savedItem?.ibsCbsDigitacaoManual,
      ibsCbsBaseCalculo: savedItem?.ibsCbsBaseCalculo,
      ibsAliquota: savedItem?.ibsAliquota,
      ibsAliquotaMun: savedItem?.ibsAliquotaMun,
      ibsValor: savedItem?.ibsValor,
      ibsValorMun: savedItem?.ibsValorMun,
      cbsAliquota: savedItem?.cbsAliquota,
      cbsAliquotaMun: savedItem?.cbsAliquotaMun,
      cbsValor: savedItem?.cbsValor,
      cbsValorMun: savedItem?.cbsValorMun,
    });

    this.cdr.detectChanges();
  }

  trackByFn(index, item) {
    return item.id.fatProduto.id;
  }

   openProdutoDetails(produto: Produto) {
    console.log('openProdutoDetails', produto);
    const isMobile = !!this.layoutConf?.isMobile;
    const dialogRef: MatDialogRef<any> = this.dialog.open(ProdutoDetailsComponent, {
      width: isMobile ? '100vw' : '80%',
      height: isMobile ? '100dvh' : '90%',
      maxWidth: isMobile ? '100vw' : '90vw',
      panelClass: isMobile ? 'mobile-fullscreen-dialog' : undefined,
      autoFocus: false,
      restoreFocus: false,
      disableClose: true,
      data: { produto: produto }, // Passa o produto como dado para o popup
    });
  
    dialogRef.afterClosed().subscribe((res) => {
      if (res) {
        this.snack.open('Produto atualizado com sucesso!', 'OK', {
          duration: 5500,
          verticalPosition: 'top',
        });
      }
    });
  }
   openManutencaoPreco(produto: Produto) {
    console.log('openManutencaoPreco', produto);
    const dialogRef: MatDialogRef<any> = this.dialog.open(ProdutoManutencaoPrecoComponent, {
      width: '80%',  
      height: '90%',  
      disableClose: true,  
      data: { produto: produto }, // Passa o produto como dado para o popup
    });
  
    dialogRef.afterClosed().subscribe((res) => {
      if (res) {
        this.snack.open('Produto atualizado com sucesso!', 'OK', {
          duration: 5500,
          verticalPosition: 'top',
        });
      }
    });
  }

  // Ordena o FormArray "items" por código, descrição ou inclusão.
  sortByProduto(by: 'codigo' | 'descricao' | 'issueDate') {
    const arr = this.itemFormArray as FormArray;
    if (!arr || !arr.controls?.length) {
      return;
    }

    const currentDirection = this.sortDir[by] || 'asc';
    const directionFactor = currentDirection === 'asc' ? 1 : -1;

    if (by === 'issueDate' && this.lcto?.controle) {
      this.selectedItemOrdem = 'ISSUEDATE';
      this.selectedItemDirect = currentDirection.toUpperCase();

      if (this.searchInput && this.searchInput.length > 0) {
        this.getSearchPageItem(this.searchInput, this.pageItem || 1, this.pageSizeItem);
      } else {
        this.getPageItem(this.pageItem || 1, this.pageSizeItem, this.lcto?.controle);
      }

      this.sortDir[by] = currentDirection === 'asc' ? 'desc' : 'asc';
      this.cdr.markForCheck?.();
      return;
    }

    // Para Código/Descrição, mantém ordenação local no grid.
    this.selectedItemOrdem = 'NENHUM';
    this.selectedItemDirect = 'ASC';

    const controls = arr.controls
      .map((ctrl: any, index: number) => ({ ctrl, index }))
      .sort((a: any, b: any) => {
        const aValue = a?.ctrl?.value;
        const bValue = b?.ctrl?.value;
        const produtoA = aValue?.id?.fatProduto ?? {};
        const produtoB = bValue?.id?.fatProduto ?? {};

        const va = by === 'codigo'
          ? Number(produtoA?.codigo ?? 0)
          : String(produtoA?.descricao ?? '').toLocaleLowerCase();

        const vb = by === 'codigo'
          ? Number(produtoB?.codigo ?? 0)
          : String(produtoB?.descricao ?? '').toLocaleLowerCase();

        if (va < vb) {
          return -1 * directionFactor;
        }
        if (va > vb) {
          return 1 * directionFactor;
        }
        return (a.index - b.index) * directionFactor;
      })
      .map((entry: any) => entry.ctrl);

    // Recria o FormArray na ordem ordenada
    while (arr.length) {
      arr.removeAt(arr.length - 1);
    }
    controls.forEach((c: any) => arr.push(c));

    // Alterna para a próxima direção ao próximo clique.
    this.sortDir[by] = currentDirection === 'asc' ? 'desc' : 'asc';
    this.cdr.markForCheck?.();
  }

  

}